// eventLines — the agreed total of an event, derived from event_line_items
// and never stored. One place for the arithmetic so the form, the list and
// the payments panel cannot disagree.
//
//   line total  = unit_amount × quantity × (1 + tax_percent / 100)
//   taxable     = Σ unit_amount × quantity
//   tax         = Σ unit_amount × quantity × tax_percent / 100
//   total       = taxable + tax
//
// Internal working-out only: no document, no GSTIN, no SAC codes.

const num = (v, dflt = 0) => { const n = Number(v); return v === '' || v === null || v === undefined || Number.isNaN(n) ? dflt : n; };
const round2 = (n) => Math.round(n * 100) / 100;

export const lineBase = (l) => num(l.unit_amount) * num(l.quantity, 1);
export const lineTax = (l) => lineBase(l) * num(l.tax_percent) / 100;
export const lineTotal = (l) => round2(lineBase(l) + lineTax(l));

export const lineTotals = (lines) => {
  const list = lines || [];
  const taxable = round2(list.reduce((s, l) => s + lineBase(l), 0));
  const tax = round2(list.reduce((s, l) => s + lineTax(l), 0));
  return { taxable, tax, total: round2(taxable + tax), count: list.length };
};

/** Agreed total, or null when there are no lines (nothing agreed yet). */
export const agreedTotal = (lines) => (lines && lines.length ? lineTotals(lines).total : null);

export const fmtMoney = (n) => (n === null || n === undefined || n === '' ? '' : `₹${Number(n).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`);
